const getOrCreateLegendTable = (chart, id) => {
    const legendContainer = document.getElementById(id);
    let tableContainer = legendContainer.querySelector('table');
    if (!tableContainer) {
        let tableTitles = [];
        if (chart.userOptions.options.unit === 'percentage') {
            tableTitles = ['Segment', 'Percentage'];
        } else {
            tableTitles = ['Segment', 'Amount'];
        }
        tableContainer = `<table class="legend-table has-marker">
                <thead>
                    <tr>`;
        tableTitles.forEach(element => tableContainer += `<th scope="col">${element}</th>`);
        tableContainer += `</tr>
                </thead>
                <tbody>
                </tbody>
            </table>`;
        legendContainer.innerHTML = tableContainer;
        tableContainer = legendContainer.querySelector('table');
    }

    return tableContainer;
};

const getOrCreateLegendList = (chart, id) => {
    const legendContainer = document.getElementById(id);
    if (!legendContainer) {
        console.warn(`Legend container with ID '${id}' not found`);
        return null;
    }
    let listContainer = legendContainer.querySelector('ul');
    if (!listContainer) {
      listContainer = document.createElement('ul');
      //column is the equivalent of bar in highcharts
      if (chart.types[0] == 'column') {
          legendContainer.insertBefore(listContainer, legendContainer.firstChild);  
      } else {
          legendContainer.appendChild(listContainer);
      }
    }
  
    return listContainer;
  };

const formatLegendValue = (value, config) => {
    const { unit, hide_legend_unit, custom_unit } = config;
    
    // Check for intentionally blank or 0 values first
    if (value === 0 || value === null || value === '') {
        return "--"; // Display "--" for blank or zero values
    }

    value = parseFloat(value);

    let formattedValue;
    
    if (unit === 'percentage') {
        // Whole numbers stay as integers; decimals always show two places
        formattedValue = value % 1 === 0 ? value.toString() : value.toFixed(2);
        if (!hide_legend_unit) {
            formattedValue += '%';
        }
    } else {
        // Determine the effective unit for this specific value
        let effectiveUnit = unit;
        if (unit === 'billion' && value < 1 && !hide_legend_unit) {
            value *= 1000; // Convert to millions for values less than 1 billion
            effectiveUnit = 'million'; // Temporarily adjust the unit for this value
        } else if (unit === 'million' && value >= 1000 && !hide_legend_unit) {
            value /= 1000; // Convert to billions for values equal to or greater than 1000 million
            effectiveUnit = 'billion'; // Temporarily adjust the unit for this value
        }

        // Whole numbers stay as integers; decimals always show two places
        if (value % 1 === 0) {
            formattedValue = value.toString();
        } else {
            formattedValue = value.toFixed(2);
        }

        // Append the unit if the legend unit is not supposed to be hidden
        if (!hide_legend_unit) {
            switch (effectiveUnit) {
                case 'currency': {
                    const [intPart, decPart] = formattedValue.split('.');
                    const groupedInt = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                    formattedValue = `$${decPart !== undefined ? `${groupedInt}.${decPart}` : groupedInt}`;
                    break;
                }
                case 'million':
                    formattedValue += 'M';
                    break;
                case 'billion':
                    formattedValue += 'B';
                    break;
                default:
                    if (custom_unit) formattedValue += `${custom_unit}`;
                    break;
            }
        }
    }
    return formattedValue;
};

const setCustomLegend = function (chart,id) {
    const {userOptions} = chart;
    const {options} = chart.userOptions;
    const {chartType} = options;
    const legendContainer = document.getElementById(id) || document.getElementById(id + "-2");
    
    if (legendContainer) {
        legendContainer.classList.add(`${chartType}`);
    }
    if ((chartType === 'pie' || chartType === 'doughnut') && options.type == 'table') {
        setTableLegend(chart, id);
    } else if ((chartType === 'pie' || chartType === 'doughnut') || options.type == 'list') {
        setListLegend(chart, id);
    } else {
        let legendContainer = document.getElementById(id);
        if (!legendContainer) {
            legendContainer = document.getElementById(id + "-2");
        }
        
        const table = document.createElement('table');
        table.className = 'legend-table';
        const thead = document.createElement('thead');
        const tbody = document.createElement('tbody');

        const trLabel = document.createElement('tr');
        const thLabel = document.createElement('th');
        const labelText = options.xTitle;
        thLabel.textContent = labelText || 'Year';
        trLabel.appendChild(thLabel);

        const items = userOptions.multiData ? chart.series : chart.series[0].data
        items.forEach((dataset, datasetIndex) => {
            const th = document.createElement('th');
            th.className = 'dataset-heading';
            if (chartType == 'line') {
                pointStyle = settings.pointStyles[datasetIndex];
            }
            // Create the label span
            const labelSpan = document.createElement('span');
            labelSpan.textContent = dataset.name;

            // Create the screen reader only span if needed
            let srSpan;
            if (dataset.sr_text) {
                srSpan = document.createElement('span');
                srSpan.className = 'visually-hidden';
                srSpan.textContent = dataset.sr_text;
            }
        
            // Create the background color span
            const colorSpan = document.createElement('span');
            colorSpan.style.background = chartType === 'line' ? dataset.borderColor : dataset.color;
            if (chartType === 'line') {
                colorSpan.className = pointStyle;
            }
            colorSpan.style.display = 'inline-block';
            colorSpan.style.width = '15px';
            colorSpan.style.height = '15px';
            colorSpan.style.marginRight = '8px';
        
            // Create the wrapper span
            const wrapperSpan = document.createElement('span');
            wrapperSpan.className = 'label-wrapper';
        
            // Append the colored span and the label span to the wrapper
            wrapperSpan.appendChild(colorSpan);
            wrapperSpan.appendChild(labelSpan);
        
            // Append the screen reader only span if it exists
            if (srSpan) {
                wrapperSpan.appendChild(srSpan);
            }
        
            // Append the wrapper span to the table header
            th.appendChild(wrapperSpan);
            
            trLabel.appendChild(th);
        });

        thead.appendChild(trLabel);

        userOptions.data.labels.forEach((label, index) => {
            const tr = document.createElement('tr');
            const tdLabel = document.createElement('th');
            tdLabel.textContent = label;
            tr.appendChild(tdLabel);
        
            userOptions.data.datasets.forEach((dataset, datasetIndex) => {
                const td = document.createElement('td');
        
                // Fetch the dataset value for this label and format it using the formatLegendValue function
                let value = dataset.data[index];
                value = formatLegendValue(value, chart.userOptions.options);
        
                // Set the formatted value as the text content of the td element
                td.textContent = value;
        
                // Append the td to the tr
                tr.appendChild(td);
            });
        
            // Append the tr to the tbody
            tbody.appendChild(tr);
        });
        table.appendChild(thead);
        table.appendChild(tbody);
        legendContainer.innerHTML = ''; // Clear the container
        legendContainer.appendChild(table);
    }
}

const setTableLegend = function(chart, id) {
    const table = getOrCreateLegendTable(chart, id);
    if (!table) return;
    
    const tbody = table.querySelector('tbody');
    
    // Remove old legend items
    while (tbody && tbody.firstChild) {
        tbody.firstChild.remove();
    }

    // Check if chart series exist
    if (!chart.series || !chart.series[0] || !chart.series[0].data) {
        console.warn('Chart series data not available');
        return;
    }

    // Reuse the built-in legendItems generator
    const items = chart.series[0].data;

    items.forEach((item, datasetIndex) => {
        const row = document.createElement('tr');
    
        // Color Box
        const boxSpan = document.createElement('span');
        boxSpan.style.background = item.color;
        boxSpan.style.display = 'inline-block';
        boxSpan.style.height = '15px';
        boxSpan.style.marginRight = '8px';
        boxSpan.style.width = '15px';
        boxSpan.setAttribute('aria-hidden', 'true');
    
        // Text
        const textNode = document.createTextNode(item.name);
    
        // Label cell
        const labelCell = document.createElement('th');
        labelCell.className = 'label';
        labelCell.appendChild(boxSpan);
        labelCell.appendChild(textNode);
    
        // Value Cell
        const valueCell = document.createElement('td');
        valueCell.className = 'value';
    
        // Fetch the dataset value and format it using the formatLegendValue function
        let value = item.y;
        value = formatLegendValue(value, chart.userOptions.options);
    
        // Create a text node for the value and append it to the value cell
        const valueNode = document.createTextNode(value);
        valueCell.appendChild(valueNode);
    
        // Append label and value cells to the row
        row.appendChild(labelCell);
        row.appendChild(valueCell);
        row.style.textDecoration = item.hidden ? 'line-through' : '';
    
        // Append the row to the tbody
        tbody.appendChild(row);
    });
}

const setListLegend = function (chart, id) {
    const {userOptions} = chart;
    const {options} = chart.userOptions;
    const {chartType} = options;
    const ul = getOrCreateLegendList(chart, id);
        
    // Remove old legend items
    while (ul.firstChild) {
        ul.firstChild.remove();
    }

    const items = userOptions.multiData ? chart.series : chart.series[0].data;
    items.forEach((item, datasetIndex) => {
        const li = document.createElement('li');
        
        let pointStyle = '';
        if (typeof settings !== 'undefined' && settings && chartType == 'line') {
            pointStyle = settings.pointStyles[datasetIndex];
            item.color = settings.lineColors[datasetIndex];
        }
        
        // Color box
        const boxSpan = document.createElement('span');
        boxSpan.style.background = options.type == 'list' ? item.color : item.strokeStyle;
        boxSpan.style.borderColor = item.strokeStyle;
        boxSpan.style.borderWidth = item.lineWidth + 'px';
        boxSpan.style.display = 'inline-block';
        boxSpan.style.verticalAlign = 'middle';
        boxSpan.style.height = '15px';
        boxSpan.style.marginRight = '8px';
        boxSpan.style.width = '15px';
        if (pointStyle) {
            boxSpan.classList.add(pointStyle);
        }
        
        // Text
        const textContainer = document.createElement('p');
        textContainer.style.color = item.fontColor;
        textContainer.style.margin = 0;
        textContainer.style.padding = 0;
        textContainer.style.display = 'inline-block';
        textContainer.style.verticalAlign = 'middle';
        textContainer.style.textDecoration = item.hidden ? 'line-through' : '';
        
        const text = document.createTextNode(item.name);
        textContainer.appendChild(text);
        
        li.appendChild(boxSpan);
        li.appendChild(textContainer);
        ul.appendChild(li);
    });
}

const displayRotateLabel = function (id, chartData, cdId) {
    //calculate label rotation angle
    let dataPoints = chartData.length;
    if (dataPoints > 1) {
        let slope = (chartData[dataPoints - 1].plotY - chartData[0].plotY) / 
                    (chartData[dataPoints - 1].plotX - chartData[0].plotX);
        let angle = Math.atan(slope) * (180 / Math.PI);
        let rotateValue = Math.ceil(angle);
        // Display and rotate the CAGR label after load       
        let thisContainer = document.querySelector('#' + id);
        if (thisContainer) {
            let thisLabel = thisContainer.querySelector(".cagr-label-" + cdId);
            if (thisLabel) {
                let attrTransform = thisLabel.getAttribute('transform');
                thisLabel.setAttribute('transform', attrTransform + ' rotate(' + rotateValue + ')' )
                thisLabel.style.opacity = 1;
            } 
        }
    }
}

// Function to abbreviate a number to its power of 10's suffix
const abbreviateNumber = function (number) {
    const SI_SYMBOL = ["", "K", "M", "B", "t", "q", "Q"];
    let tier = Math.log10(Math.abs(number)) / 3 | 0;
    
    if (tier === 0) {
        return number;
    }
    
    let suffix = SI_SYMBOL[tier];
    let scale = Math.pow(10, tier * 3);
    let scaled = number / scale;
    
    return scaled.toFixed(0) + suffix;
}

const removeTabindex = function (className) {
    const elements = document.querySelectorAll(`.${className}[tabindex="0"]`);
    if (elements.length > 0 ) {
        elements.forEach(element => {
            element.removeAttribute('tabindex');
        });
    }
}

const fixElementRole = function (className, role) {
    const elements = document.querySelectorAll(`.${className}`);
    if (elements.length > 0 ) {
        elements.forEach(element => {
            element.setAttribute('role', role);
        });
    }
}

const addAccessibilityAttributes = function (chart) {
    setTimeout(() => {
        chart.series.forEach(series => {
            if (series.group && series.group.element) {
                // Add role graphics-object to all child elements of the series group
            Array.from(series.group.element.children).forEach(child => {
                    child.setAttribute('role', 'graphics-object');
                });
            }
        });
    }, 1000);
}